var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-wrapper p-4 middle:pt-16"},[(_vm.config.series.length)?_c('chart',{ref:"chart",attrs:{"config":_vm.config}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }